/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ES': {
    width: 16,
    height: 16,
    viewBox: '0 0 15 11',
    data: '<clipPath id="svgicon-ES-a"><path pid="0" d="M14.75 2.25c0-1.097-.903-2-2-2H2.25c-1.097 0-2 .903-2 2v6.5c0 1.097.903 2 2 2h10.5c1.097 0 2-.903 2-2v-6.5z"/></clipPath><g clip-path="url(#svgicon-ES-a)" fill-rule="nonzero"><path pid="1" d="M0 0h15v2.933H0V0zm0 8.067h15V11H0V8.067z" _fill="#dd172c"/><path pid="2" _fill="#ffd133" d="M0 2.933h15v5.133H0z"/><path pid="3" d="M3.929 5.133h.714v.5h-.715l.001-.5z" _fill="#ffedb1"/><path pid="4" d="M3.929 6.605a.598.598 0 0 1-.183.028V7.3h.365v-.667a.591.591 0 0 1-.182-.028z" _stroke="#a41517" stroke-width=".66"/><path pid="5" d="M3.214 5.5h1.429v.367h-.358l-.356.733-.356-.733h-.358L3.214 5.5zM2.143 4.4h.974v2.567h-.974V4.4zM5 4.4h.974v2.567H5V4.4zm-1.786-.367c0-.202.153-.366.36-.366h.708c.199 0 .361.17.361.366v.035a.338.338 0 0 1-.331.332h-.775a.33.33 0 0 1-.323-.332v-.035z" _fill="#a41517"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/ES.js